export class EnumExt {
    public static IsEnum(value: any, entity: any) {
        return EnumExt.GetValues(entity).indexOf(value) >= 0;
    }

    public static GetValues(entity: any) {
        return EnumExt.GetKeys(entity).map(function (k) {
            return entity[k];
        });
    }

    public static GetKeys(entity: any) {
        return Object.keys(entity)
            .filter((k) => isNaN(Number(k)))
            .filter((k) => typeof entity[k] === 'number' || typeof entity[k] === 'string');
    }

    public static GetKey(value: any, entity: any): string {
        const key = EnumExt.GetKeys(entity).find((key) => {
            return entity[key] === value;
        });

        if (key === undefined) {
            throw new Error(`Cannot determine key for value ${value} given the entity ${entity}`);
        }

        return key;
    }
}
